import LogonHelper from '@/helper/LogonHelper'
import Logon from '@/models/Logon'
import Init from '@/Init'
import Vue from 'vue'

export default {
  data () {
    return {
      snackbar: false,
      message: '',
      loginForm: {
        valid: false,
        loading: false,
        fields: {}
      },
      rules: {}
    }
  },
  beforeMount () {
    this.rules = Logon.validators()
    this.loginForm.fields = Logon.parserFrom({}).attrs
  },
  methods: {
    login: function () {
      if (this.$refs.logon.validate()) {
        let data = {
          username: this.loginForm.fields.username,
          password: this.loginForm.fields.password
        }

        LogonHelper.login(data)
          .then((res) => {
            this.$store.dispatch('logged', {
              fullname: res.fullname,
              username: data.username,
              token: res.token
            })

            Vue.prototype.$http.defaults.headers.common['Token-Auth'] = res.token

            Init()

            this.$router.push('/')
          })
          .catch((err) => {
            this.message = err.error
            this.snackbar = true
          })
      }
    }
  }
}
